import script from "./CommunityListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityListView.vue?vue&type=script&setup=true&lang=js"

import "./CommunityListView.vue?vue&type=style&index=0&id=4b7ae240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7ae240"]])

export default __exports__